import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTooltipTruncateModule } from '@y42/core/mat-tooltip-truncate';
import { IntercomModule } from '@y42/intercom';
import { AssetSidebarTabDirective } from './asset-sidebar-tab.directive';
import { AssetSidebarComponent } from './asset-sidebar.component';

@NgModule({
  declarations: [AssetSidebarComponent, AssetSidebarTabDirective],
  exports: [AssetSidebarComponent],
  imports: [
    CommonModule,
    RouterModule,

    MatSidenavModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatTooltipTruncateModule,

    FontAwesomeModule,

    IntercomModule,
  ],
})
export class AssetSidebarModule {}
